import Box from "@mui/material/Box"

type BoxProps = {
  children: JSX.Element | JSX.Element[]
}

export default function (props: BoxProps) {
  return <Box>{props.children}</Box>
}
